import { render, staticRenderFns } from "./BaseSwitcher.vue?vue&type=template&id=c93866ec&scoped=true"
import script from "./BaseSwitcher.vue?vue&type=script&lang=js"
export * from "./BaseSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BaseSwitcher.vue?vue&type=style&index=0&id=c93866ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93866ec",
  null
  
)

export default component.exports